import { FC, ReactNode } from 'react';
import { Tag, Typography } from '@flash-tecnologia/hros-web-ui-v2';

interface BaseLayoutProps {
  children: ReactNode;
  title: string;
  subTitle?: string | JSX.Element;
  optional?: boolean;
}

export const InputLayout: FC<BaseLayoutProps> = ({
  children,
  title,
  subTitle,
  optional = false,
}) => {
  return (
    <div
      style={{
        border: '1px solid #EBE6E9',
        borderRadius: '8px',
        padding: '32px',
      }}
    >
      <Typography
        variant="headline8"
        style={{ fontWeight: '700', color: '#53464F' }}
      >
        {title}
        <span
          style={{
            display: 'inline-flex',
            marginLeft: '10px',
            verticalAlign: 'middle',
          }}
        >
          <Tag variant={optional ? 'gray' : 'primary'} size="extra-small">
            {optional ? 'Opcional' : 'Obrigatório'}
          </Tag>
        </span>
      </Typography>
      <Typography
        variant="headline9"
        style={{ fontWeight: '400', color: '#83727D', marginTop: '5px' }}
      >
        {subTitle}
      </Typography>
      {children}
    </div>
  );
};
